// extracted by mini-css-extract-plugin
module.exports = {"pt-active-sign":"pt-active-sign-c391d8d3948fb8667e29c13118977242"};